// extracted by mini-css-extract-plugin
export default {"toolbar":"ToolbarBlocks_toolbar__9hRqV","errorText":"ToolbarBlocks_errorText__SNioC"};